import { render, staticRenderFns } from "./PaginationInline.vue?vue&type=template&id=6b869f38&scoped=true&"
import script from "./PaginationInline.vue?vue&type=script&lang=js&"
export * from "./PaginationInline.vue?vue&type=script&lang=js&"
import style0 from "./PaginationInline.vue?vue&type=style&index=0&id=6b869f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b869f38",
  null
  
)

export default component.exports